/**
 * Options configs for the Data Management view.
 * Used by OptionsDialog to render restore/destruction preference forms.
 * Keys = Labels so that human-readable text flows through to the email.
 */

export const restoreOptionsConfig = {
    title: "How do you want your files?",
    subtitle: "(select at least one option)",
    items: [
        {
            CategoryName: "Cloud Restore",
            Key: "Cloud Restore requested",
            Label: "Cloud Restore",
            Type: "toggleInput",
        },
        {
            CategoryName: "Cloud Restore",
            SubCategoryName: "Extra options",
            Key: "I want to have a signed URL for my files",
            Label: "I want to have a signed URL for my files",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Cloud Restore requested", DependencyType: "disabled_when_falsy"}},
        },
        {
            CategoryName: "Cloud Restore",
            SubCategoryName: "Extra options",
            Key: "I want the files to be accessible for a specific time.",
            Label: "I want the files to be accessible for a specific time.",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Cloud Restore requested", DependencyType: "disabled_when_falsy"}},
        },
        {
            CategoryName: "Cloud Restore",
            SubCategoryName: "Extra options",
            Key: "I want the files to be put into the folder of tape names they belong to.",
            Label: "I want the files to be put into the folder of tape names they belong to.",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Cloud Restore requested", DependencyType: "disabled_when_falsy"}},
        },
        {
            CategoryName: "Physical Restore",
            Key: "Physical Restore requested",
            Label: "Physical Restore",
            Type: "toggleInput",
        },
        {
            CategoryName: "Physical Restore",
            SubCategoryName: "Extra options",
            Key: "I want the files to be sent to a different address than the source",
            Label: "I want the files to be sent to a different address than the source",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Physical Restore requested", DependencyType: "disabled_when_falsy"}},
        },
        {
            CategoryName: "Physical Restore",
            SubCategoryName: "Extra options",
            Key: "I want to choose the disk type on which the files are sent",
            Label: "I want to choose the disk type on which the files are sent",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Physical Restore requested", DependencyType: "disabled_when_falsy"}},
        },
        {
            CategoryName: "Physical Restore",
            SubCategoryName: "Extra options",
            Key: "I want the disk to have encryption enabled by default",
            Label: "I want the disk to have encryption enabled by default",
            Type: "toggleInput",
            Options: {EntryValidation: {Dependency: "Physical Restore requested", DependencyType: "disabled_when_falsy"}},
        },
    ],
};

export const destructionOptionsConfig = {
    title: "Destruction options",
    subtitle: null,
    items: [
        {
            Key: "Destruction method",
            Label: "Destruction method",
            Type: "toggleButtonGroup",
            Hint: "Virtual tapes are permanently erased.",
            Options: {
                EntrySource: [
                    {value: "Shred", label: "Shred"},
                    {value: "Incinerate", label: "Incinerate"},
                    {value: "Degauss", label: "Degauss"},
                    {value: "Recycle", label: "Recycle"},
                ],
                EntryDisplay: "label",
                EntryValue: "value",
            },
        },
    ],
};

export const restoreCanProceed = (values) => {
    return !!(values["Cloud Restore requested"] || values["Physical Restore requested"]);
};

export const destructionCanProceed = (values) => {
    return !!values["Destruction method"];
};

export const TAPE_SUMMARY_COLUMNS = [
    {name: "Volser", mnemonic: "item_volser", ui_class: "str"},
    {name: "Tape Type", mnemonic: "media_type", ui_class: "str"},
];

export const FILE_SUMMARY_COLUMNS = [
    {name: "Filename", mnemonic: "name", ui_class: "str"},
    {name: "Volser", mnemonic: "volsers", ui_class: "str"},
];
